// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1x6a4","gfeWrapper":"CalendarEvent_gfeWrapper__20ayF"};